import React, { useState } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import './AuthPage.styles.scss'

export default function AuthPage() {
  const [isRegistering, setIsRegistering] = useState(false);

  return (
    <div className="auth-page">
      {isRegistering ? <RegisterForm /> : <LoginForm />}
      <p>
        {isRegistering
          ? 'Already have an account? '
          : "Don't have an account? "}
        <button
          className="link-button"
          onClick={() => setIsRegistering(v => !v)}
        >
          {isRegistering ? 'Log In' : 'Sign Up'}
        </button>
      </p>
    </div>
  );
}
